export default __webpack_public_path__ + "static/media/call.0df5c539.svg";